export default () => ({
    menus: {}
});
